import isEmpty from 'lodash/isEmpty';
import globalHeader from '../services/globalHeader.js';
import fetch from './fetch';

/*
 * 'isHeaderValidationEnabled' parameter given in each of the functions below is an temporaray parameter
 * which will add user details in header to the APIs were the header validation is implemented.
 * This can be removed later once the header validation is implemented across all the APIs we have in our app.
 * Otherwise the custom header will break the APIs which do not have header validation implemented.
 */

export const postRequest = (url, payload, isHeaderValidationEnabled) =>
  fetch(url, {
    method: 'POST',
    ...(isHeaderValidationEnabled && { headers: globalHeader(url) }),
    body: JSON.stringify(payload)
  });

export const getRequest = (url, queryParams, isHeaderValidationEnabled) => {
  if (!isEmpty(queryParams)) {
    const queryString = Object.keys(queryParams)
      .map(
        key =>
          `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`
      )
      .join('&');
    url = `${url}?${queryString}`;
  }
  return fetch(url, {
    method: 'GET',
    ...(isHeaderValidationEnabled && { headers: globalHeader(url) })
  });
};

export const deleteRequest = (url, isHeaderValidationEnabled) =>
  fetch(url, {
    method: 'DELETE',
    ...(isHeaderValidationEnabled && { headers: globalHeader(url) })
  });

export const putRequest = (url, payload, isHeaderValidationEnabled) =>
  fetch(url, {
    method: 'PUT',
    ...(isHeaderValidationEnabled && { headers: globalHeader(url) }),
    body: JSON.stringify(payload)
  });
